<div class="app-header ms-0" style="animation-duration: 0.3s;" [ngClass]="{'d-flex d-lg-none': mobileOnly}">
  <div class="app-container container-fluid d-flex flex-stack">

    <!--begin::Sidebar toggle  -->
    <div class="d-flex align-items-center d-block d-lg-none ms-n3" title="Show sidebar menu">
      <button class="btn btn-icon btn-active-color-primary w-35px h-35px me-2" (click)="toggleSidebar()" id="sidebar-toggler">
        <span class="svg-icon svg-icon-2qx">
          <bws-mdi name="menu"/>
        </span>
      </button>
    </div>
    <!--end::Sidebar toggle -->


    <!--begin::Header wrapper-->
    <div class="d-flex w-100">
      <bws-breadcrumb class="d-none d-lg-flex"
                      [items]="breadCrumbItems"
                      [title]="breadCrumbTitle"
                      [navigateBackLink]="breadCrumbNavigateBackLink"></bws-breadcrumb>

      <ng-content></ng-content>

    </div>
    <!--end::Header wrapper-->
  </div>
</div>
